<template>
  <div class="layout_container">
    <el-container>
      <el-header style="height: 61px"
        v-bind:style="{backgroundImage:'url(' + headerBackGroundImg + ')',
        backgroundRepeat:'no-repeat',
        backgroundSize:'100% 100%'}">
        <Header />
      </el-header>
      <el-container>
        <el-aside :width="aside_width" style="overflow-x: hidden">
          <Aside />
        </el-aside>
        <el-main>
          <TagsView></TagsView>
        </el-main>
      </el-container>
    </el-container>

  </div>
</template>

<script>
import Aside from '@/components/Aside.vue'
import Header from '@/components/Header.vue'
import Main from '@/components/Main.vue'
import TagsView from "@/components/TagsView";
export default {
  name: "Container",
  components:{TagsView, Aside,Header,Main},
  data(){
    return {
      headerBackGroundImg: require(this.$store.state.isComputer?'@/assets/image/header-background.jpg':'@/assets/image/header-background1.jpg')
    }
  },
  computed: {
    aside_width () {
      return this.$store.state.menuCollapse?"64px":"200px"
    }
  }
}
</script>

<style scoped>
.el-header, .el-footer {
  background-color: #fff;
  color: #333;
  text-align: center;
  line-height: 60px;
  border-bottom: solid 1px #e6e6e6;
}

.el-aside {
  color: #333;
  line-height: 200px;
  border-right: solid 1px #e6e6e6;
  height: calc(100vh - 61px);
}

.el-main {
  background-color:  #fff;
  color: #333;
  padding: 0px;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.layout_container {
  width: 100%;
  height: 100%;
}
.el-container{
  height: 100%;
}

/deep/.el-textarea__inner{
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}

/deep/.el-table--mini .el-link{
  font-size: 12px;
}
/deep/.el-table--small .el-link{
  font-size: 12px;
}
</style>